import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * Loads the three admin endpoints (quotes, contacts, stats) in parallel
 * once the agent is authenticated. Returns the data plus a loading flag.
 * Extracted out of AgentDashboard to keep the page component readable.
 */
export default function useAdminData(user, authLoading) {
  const [quotes, setQuotes] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [stats, setStats] = useState({ quotes: 0, contacts: 0 });
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) return;
    let cancelled = false;
    (async () => {
      setFetching(true);
      try {
        const [q, c, s] = await Promise.all([
          api.get("/admin/quotes"),
          api.get("/admin/contacts"),
          api.get("/admin/stats"),
        ]);
        if (cancelled) return;
        setQuotes(q.data.items || []);
        setContacts(c.data.items || []);
        setStats(s.data || { quotes: 0, contacts: 0 });
      } finally {
        if (!cancelled) setFetching(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // q, c, s are local consts inside the IIFE; api is a module import;
    // setters are stable per React's useState contract.
  }, [user, authLoading]);

  return { quotes, contacts, stats, fetching };
}
